import { Component, Vue, PropSync, Emit, Watch } from 'vue-property-decorator';
import { ConfigurationSection } from '@/models/configuration/Section';
import { ApiIdentifers } from '@/config/index';
import { LoggerService } from '@/utils';
import { ConfigurationService } from '@/services/index';

import HeaderLogo from '@/components/general/headerlogo/HeaderLogo.vue';
import UserProfileMenu from '@/components/general/userprofilemenu/UserProfileMenu.vue';

export interface IHeaderBarComponentMethods {
    setSelectValue(inIdentifier: string): void;
}

@Component({
    components: {
        HeaderLogo,
        UserProfileMenu,
    },
})
export default class HeaderBarComponent extends Vue implements IHeaderBarComponentMethods {
    @PropSync('title', { type: String }) public syncedTitle!: string;
    @PropSync('infoData', { type: String }) public syncedInfoData!: string;
    @PropSync('filterSelection', { type: Array, default: [] }) public selectedFilterString!: string[];
    @PropSync('filteredResults', { type: String }) public filterResults!: string;

    public selectValue: string = '';
    public selectData: any = [];
    public checkboxValue: boolean = false;

    // tslint:disable-next-line: no-empty
    public mounted() {
        LoggerService.LogDebug(`before: `, this.selectData);
        this.getCardsData();
        LoggerService.LogDebug(`after: `, this.selectData);
        this.selectValue = ApiIdentifers.general;
    }

    @Emit()
    public editFilter(): boolean {
        return true;
    }

    @Emit()
    public download(): boolean {
        return true;
    }

    @Emit()
    public profile(): boolean {
        return true;
    }

    @Emit()
    public back(): boolean {
        return true;
    }

    @Emit()
    public card(identifier: string): string {
        return identifier;
    }

    @Emit()
    public showUnsynced(): boolean {
        return true;
    }

    @Emit()
    public showUnitsMenu(): boolean {
        return true;
    }

    @Emit()
    public showChanged(changed: boolean): boolean {
        return changed;
    }

    @Watch('selectValue')
    public onSelectValueChanged(newValue: string) {
        this.card(newValue);
    }

    @Watch('checkboxValue')
    public onCheckboxValueChanged(newValue: boolean) {
        this.showChanged(newValue);
    }

    public onHome() {
        this.back();
    }

    public onEditFilter() {
        this.editFilter();
    }

    public onDownload() {
        this.download();
    }

    public onProfile() {
        this.profile();
    }

    public showInfoField(): boolean {
        return this.syncedInfoData ? true : false;
    }

    public onUnsyncedList() {
        this.showUnsynced();
    }

    public showUntisMenu() {
        this.showUnitsMenu();
    }

    public setSelectValue(inIdentifier: string) {
        this.selectValue = inIdentifier;
    }

    /**
     * Method to fetch translation with fallback
     * @param field ConfigurationSection
     */
    public getIdentifierText(inSection: ConfigurationSection): string {
        let ret: string = '';
        if (inSection.identifier) {
            ret = this.$vuetify.lang.t(`$vuetify.identifiers.${inSection.identifier}`);
            if (ret.length === 0 || ret.includes('$vuetify.identifiers.')) {
                ret = inSection.name;
            }
        }

        return ret;
    }

    private getCardsData() {
        ConfigurationService.GetCompleteConfigurationSections.filter((sec) => sec.identifier !== ApiIdentifers.machineOrder).forEach((section) => {
            this.selectData.push({ text: this.getIdentifierText(section), value: section.identifier });
        });
    }
}
